import Rox from 'rox-browser';

export const FlagsWebinar = {
  webinar_enable: new Rox.Flag(false),
};

export function initFlagsWebinar() {
  // register flags with namespaces for better grouping
  Rox.register("featureWebinar", FlagsWebinar);
}
